import http from "./axios"
import {SYSTEM} from "./api"

/**
 * 用户登录
 */
export function userLogin(form){
    return http.post(SYSTEM.USER.LOGIN,form)
}

export function getUserInfo(){
    return http.get(SYSTEM.USER.INFO)
}

/**
 * 获取管理员列表
 */
export function userList(data){
    return http.get(SYSTEM.USER.USER_LIST,{
        params:{
            ...data
        }
    })
}
/**
 * 首页统计数据
 */
export function getHomeData(data){
    return http.get(SYSTEM.HOME.HOME,{
        params:{
            ...data
        }
    })
}

/**
 *删除管理员
 */
export function delUserList(form){
    return http.post(SYSTEM.USER.DEL_USER,form)
}

/**
 * 重置用户密码
 */
export function reSetPsw(form){
    return http.post(SYSTEM.USER.REFRESH_PSW,form)
}

/**
 * 用户启用禁用
 */
export function enableUser(form){
    return http.post(SYSTEM.USER.ENABLE,form)
}

/**
 * 更新用户信息
 */
export function upDataUser(falg,form){
    if(falg){
        return http.post(SYSTEM.USER.EDIT,form)
    }else{
        return http.post(SYSTEM.USER.ADD,form)
    }
}

/**
 * 修改密码
 */
export function editPswUser(form){
    return http.post(SYSTEM.USER.EDIT_PSW,form)
}

/**
 * 角色列表
 */
export function roleList(data){
    return http.get(SYSTEM.ROLE.ROLE_LIST,{
        params:{
            ...data
        }
    })
}

/**
 * 删除角色
 */
export function delRole(form){
    return http.post(SYSTEM.ROLE.DEL,form)
}

/**
 * 启用禁用角色
 */
export function enableRole(form){
    return http.post(SYSTEM.ROLE.ENABLE,form)
}

/**
 * 更新角色信息
 */
export function upDataRole(falg,form){
    if(falg){
        return http.post(SYSTEM.ROLE.EDIT,form)
    }else{
        return http.post(SYSTEM.ROLE.ADD,form)
    }
}



// WEBPACK FOOTER //
// ./src/api/system.js